import React from "react";
import LoadingGif from "../../images/loading.gif";

export default function Loading({ style }) {
  return <img src={LoadingGif} style={{ ...style }} />;
}
